import * as yup from 'yup'

const AT_LEAST_ONE_MESSAGE = 'Enter an email, phone or partner driver ID'

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

const hasText = (value: unknown): boolean => {
  return typeof value === 'string' && value.trim() !== ''
}

export const partnerDriverSearchFormValidator = yup.object({
  // The "at least one" rule hangs off the first field so its message shows under it.
  email: yup
    .string()
    .trim()
    .test('at-least-one', AT_LEAST_ONE_MESSAGE, (value, context) => {
      return (
        hasText(value) || hasText(context.parent.phone) || hasText(context.parent.partnerDriverId)
      )
    }),
  phone: yup.string().trim(),
  // `@IsUUID` on the query DTO. Not `.uuid()`: yup v1 runs it with `excludeEmptyString: false`, so
  // an empty field would fail and block an email-only search.
  partnerDriverId: yup.string().trim().matches(UUID_PATTERN, {
    message: 'Enter a valid partner driver ID',
    excludeEmptyString: true,
  }),
})
